import { render, staticRenderFns } from "./MintDialog.vue?vue&type=template&id=2ff5e43b&scoped=true&"
import script from "./MintDialog.vue?vue&type=script&lang=js&"
export * from "./MintDialog.vue?vue&type=script&lang=js&"
import style0 from "./MintDialog.vue?vue&type=style&index=0&id=2ff5e43b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5e43b",
  null
  
)

export default component.exports